(function () {
  'use strict';

  angular.module('app').service('HotelModalService', HotelModalService);

  HotelModalService.$inject = ['ModalService'];

  function HotelModalService(ModalService) {
    var service = {
      openHotelListModal: openHotelListModal,
    };

    return service;

    ////////////////

    // --------------------------- openHotelListModal -------------------------

    function openHotelListModal(websiteId) {
      // hotelIds
      ModalService.showModal({
        templateUrl: './app/ajs/hotels/modals/hotel-list-modal.html',
        controller: HotelListsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          //   hotelIds: hotelIds,
          websiteId: websiteId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      HotelListsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'HotelService',
        'websiteId',
      ];
    }

    function HotelListsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      HotelService,
      websiteId
    ) {
      // hotelIds,
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_hotel_accountadmin'),
        canCreate: AbilityService.can('create_hotel_accountadmin'),
        canUpdate: AbilityService.can('update_hotel_accountadmin'),
        canDestroy: AbilityService.can('destroy_hotel_accountadmin'),
      };

      vm.modalTitle = 'HOTELS';

      // Methods
      vm.showHotel = showHotel;
      vm.addContent = addContent;

      // Initializers
      getHotels();

      function getHotels() {
        vm.loadingItems = true;
        var params = {
          get: 'active',
          only: 'basic',
          usage: true,
          website_id: websiteId,
        };

        HotelService.getHotels(params).then(function (data) {
          vm.hotels = data.items;
          vm.loadingItems = false;
        });
      }

      function showHotel(hotel) {
        if (!vm.permissions.canShow) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location.path(`/hotels/${hotel.id}`);
        }, 200);
      }

      function addContent(hotel) {
        if (!vm.permissions.canCreate) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location.path(`/hotel_contents/new`).search({ WSID: websiteId, hotelId: hotel.id });
        }, 200);
      }
    }
  }
})();
